import { render, staticRenderFns } from "./ItemWriteAutoComponent.vue?vue&type=template&id=2796d290&scoped=true&"
import script from "./ItemWriteAutoComponent.vue?vue&type=script&lang=js&"
export * from "./ItemWriteAutoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796d290",
  null
  
)

export default component.exports